export default __webpack_public_path__ + "static/media/tasset_of_tribulation.4bdfda5d.jpg";